import React from 'react'


function HeroBanner({ bannerimg, tittle }) {
    return (
        <div className='heroBanner d-flex justify-content-center align-items-center' >
            <img src={bannerimg} />
            <div className='heroBanner-text d-flex text-white align-items-center'>
                <h1 className='font-face-PlusJakartaSans-Bold'>{tittle}</h1>
            </div>
        </div>
    )
}

export default HeroBanner